import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { ThNavHeader } from './ThNavHeader';
import { ThNavFooter } from './ThNavFooter';

import { getClientId } from './utils/analyticsclientIdUtils';

class ThAuthForgotDetailErrClass extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);

        {
            // Google analytic
            const documentPath = "Th ForgotPwd - error"; // Gets the current URL path
            const clientId = getClientId(); // Use the getClientId function

            // Push data to the GTM dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'pageview',
                page: documentPath,
                clientId: clientId,
            });
        }
    }

    render() {
    return (
        <>
            <ThNavHeader />

            <main id="main">
                <section className="top-sr-bg bg-gray1">
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col col-md-6">
                                <h1 className="text-headpage text-white mb-0 pt-3 pb-3 "><span className="text-black">สตาร์บัคส์ รีวอร์ด</span></h1>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-sign-in overflow-hidden pb-5">
                    <div className="container-fluid p-3 p-md-0">
                        <div className="row">
                            <div className="col-md-12 mb-4 pt-3 text-center">
                                <p className="text-gray">คุณไม่ได้ตั้งรหัสผ่านใหม่ภายในเวลาที่กำหนด กรุณาขอตั้งรหัสผ่านใหม่อีกครั้ง ขอบคุณ</p>
                                <p className="text-gray"><Link to="/thforgotpwd">คลิกที่นี่ เพื่อกลับเข้าสู่หน้า ลืมรหัสผ่าน</Link></p>
                            </div>
                        </div>                        
                    </div>
                </section>
            </main>

            <ThNavFooter />
      </>
    );
  }
}

export const ThAuthForgotDetailErr = withRouter(ThAuthForgotDetailErrClass);